import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import Sidebar from "../common/sidebar";
import { BaseUrl } from "../common/config";
import { http } from "../helper";
import CKEditor from "ckeditor4-react";
import { useNavigate } from "react-router-dom";
import ShowAlert from "../common/Showalert";
import CommonAlert from "../common/Commonalert";
import RichTextEditor from "../common/richTextEditor";
import { useTranslation } from "react-i18next";
import EmailDynamicContentInfo from "../common/emailDynamicContentInfo";
import { RESTRICTED_EMAIL_TYPES } from "../common/constants";
const AddEmailConfig = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const emailTypes = [
    { name: t("customer_intro_email_txt"), value: "customer_intro" },
    { name: t("logged_in_ordered_email_txt"), value: "logged_in_not_order" },
    {
      name: t("logged_in_ordered_email_cutoff_txt"),
      value: "logged_in_not_order_cutoff",
    },
    { name: t("abandoned_cart_email_txt"), value: "abandoned_cart" },
  ];
  const [emailTemplateData, setEmailTemplateData] = useState({
    templateName: "",
    emailType: "",
    emailSubject: "",
    emailContent: "",
    header: true,
    footer: true,
    reminderInterval: "",
    reminderEmailSubject: "",
    reminderEmailContent: "",
    reminderCountLimit: "",
    reminderHeader: true,
    reminderFooter: true,
  });
  const [emailTemplateList, setEmailTemplateList] = useState([]);
  const [availableEmailTypeOptions, setAvailableEmailTypeOptions] =
    useState(emailTypes);
  const [errors, setErrors] = useState({});
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertErrorPopup, setAlertErrorPopup] = useState(false);
  const [alertErrorMessage, setAlertErrorMessage] = useState("");
  const [isCustomInterval, setIsCustomInterval] = useState(false);
  const [customInterval, setCustomInterval] = useState("");

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/"; // redirect to login if not logged in
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) !== "" &&
    !JSON.parse(
      sessionStorage.getItem("authData")
    ).adminRole.permissions.includes("manage_emailcampaign")
  ) {
    window.location.href = "/unauthorized"; // no permission, go to unauthorized page
  }

  useEffect(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }

    let URL = BaseUrl + `admin/emailConfigs`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data || [];
        // remove restricted types
        const filteredData = responseData.filter(
          (item) => !RESTRICTED_EMAIL_TYPES.includes(item.emailType),
        );
        setEmailTemplateList(filteredData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (emailTemplateList.length === 0) return;
    const usedTypes = new Set(emailTemplateList.map((t) => t.emailType));
    setAvailableEmailTypeOptions(
      emailTypes.filter(
        (opt) =>
          !usedTypes.has(opt.value) &&
          !RESTRICTED_EMAIL_TYPES.includes(opt.value),
      ),
    );
  }, [emailTemplateList]);

  const routeChange = () => {
    navigate("/email-configuration");
  };

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const formvalidation = () => {
    const errmsg = {};
    let isValid = true;

    // for (const [key, value] of Object.entries(emailTemplateData)) {
    //     if (typeof value === "string" && stripHtml(value).trim() === "") {
    //         isValid = false;
    //         errmsg[key]= "This field is required" ;
    //     }
    // }
    if (!emailTemplateData.templateName.trim()) {
      errmsg.templateName = t("field_require_txt");
      isValid = false;
    }
    if (!emailTemplateData.emailType.trim()) {
      errmsg.emailType = t("field_require_txt");
      isValid = false;
    }
    if (!emailTemplateData.emailSubject.trim()) {
      errmsg.emailSubject = t("field_require_txt");
      isValid = false;
    }
    if (!stripHtml(emailTemplateData.emailContent).trim()) {
      errmsg.emailContent = t("field_require_txt");
      isValid = false;
    }

    // Conditional fields (only for logged_in_not_order and abandoned_cart)
    if (
      emailTemplateData.emailType === "logged_in_not_order" ||
      emailTemplateData.emailType === "abandoned_cart" ||
      emailTemplateData.emailType === "logged_in_not_order_cutoff"
    ) {
      if (
        !emailTemplateData.reminderInterval ||
        isNaN(emailTemplateData.reminderInterval)
      ) {
        errmsg.reminderInterval = t("field_require_txt");
        isValid = false;
      }
      if (
        !emailTemplateData.reminderCountLimit ||
        isNaN(emailTemplateData.reminderCountLimit)
      ) {
        errmsg.reminderCountLimit = t("field_require_txt");
        isValid = false;
      }

      if (!emailTemplateData.reminderEmailSubject.trim()) {
        errmsg.reminderEmailSubject = t("field_require_txt");
        isValid = false;
      }
      if (!stripHtml(emailTemplateData.reminderEmailContent).trim()) {
        errmsg.reminderEmailContent = t("field_require_txt");
        isValid = false;
      }
    }
    const hasDupicateEntry = emailTemplateList.some(
      (template) =>
        template.templateName.toLowerCase() ===
        emailTemplateData.templateName.trim().toLowerCase()
    );

    if (hasDupicateEntry) {
      var alertmsg = "";
      alertmsg = t("email_config_duplicate_txt");
      setAlertErrorMessage(alertmsg);
      setAlertErrorPopup(true);
      isValid = false;
    }
    setErrors(errmsg);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = formvalidation();
    if (isValid) {
      const payload = emailTemplateData;
      http
        .post(BaseUrl + "admin/emailConfig", payload)
        .then((response) => {
          if (response.data.success) {
            const currentEmailType = emailTypes.find(
              (item) => item.value === emailTemplateData.emailType
            );
            setAlertMessage(
              t("emailconfig_create_sucess_txt", {
                emailType: currentEmailType.name,
              })
            );
          } else {
            setAlertMessage(t("something_went_wrongs_txt"));
          }
          setAlertPopup(true);
          //   setTimeout(() => {
          //     routeChange();
          //   }, 2000);
        })
        .catch((error) => {
          console.error("Save failed", error);
          setAlertErrorMessage(t("save_alert_error_txt"));
          setAlertErrorPopup(true);
        });
    }
  };

  // const handleChangeEmailContent =(name,value) => {
  //     setEmailTemplateData(prev => ({ ...prev, [name]: value }));
  //     setErrors((prevErrors) => ({
  //         ...prevErrors,
  //         [name]: "",
  //     }));
  // }
  const handleChangeEmailContent = (value) => {
    setEmailTemplateData((prev) => ({ ...prev, emailContent: value }));
    setErrors((prev) => ({ ...prev, emailContent: "" }));
  };

  const handleChangeReminderEmailContent = (value) => {
    setEmailTemplateData((prev) => ({ ...prev, reminderEmailContent: value }));
    setErrors((prev) => ({ ...prev, reminderEmailContent: "" }));
  };

  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setEmailTemplateData((prev) => ({ ...prev, [name]: value }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleIntervalChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const numberValue = value === "" ? "" : parseInt(value, 10);
    setEmailTemplateData((prev) => ({ ...prev, [name]: numberValue }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleOnCheck = (value, field) => {
    setEmailTemplateData((prev) => ({ ...prev, [field]: value }));
  };

  const formatHoursToDays = (hours) => {
    if (!hours || isNaN(hours)) return "";
    const totalHours = parseInt(hours, 10);
    const days = Math.floor(totalHours / 24);
    const remaining = totalHours % 24;
    let result = "";
    if (days > 0) {
      result += `${days} day${days > 1 ? "s" : ""}`;
    }
    if (remaining > 0) {
      if (result) result += " ";
      result += `${remaining} hour${remaining > 1 ? "s" : ""}`;
    }
    return result || "0 hours";
  };
  // let loadingClass = isLoading ? 'loading-buffer' : '';
  return (
    <section className="dashboard-block">
      {alertPopup && <CommonAlert title={t("alert_txt")} message={alertMessage} />}
      {alertErrorPopup && (
        <ShowAlert title={t("alert_txt")} message={alertErrorMessage} />
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <div className="right-table-outer-wrap">
              <h1 className="checkout-title">
                {t("add_email_config_title_txt")}
              </h1>
              {/* <div className="form-field freeproduct-fieldset masterentry-fieldset form-container-xs"> */}
              <form className="sectors-detail-form">
                <div className="input-field">
                  <label for="name">{t("template_name_txt")}</label>
                  <input
                    type="text"
                    name="templateName"
                    value={emailTemplateData.templateName}
                    onChange={handleOnChange}
                  />
                  {errors.templateName && (
                    <div className="error-msg">{errors.templateName}</div>
                  )}
                </div>

                <div className="input-field">
                  <label for="emailType">{t("email_type_txt")}</label>
                  <select name="emailType" onChange={handleOnChange}>
                    <option value="">{t("select_txt")}</option>
                    {availableEmailTypeOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                  {errors.emailType && (
                    <div className="error-msg">{errors.emailType}</div>
                  )}
                </div>

                <div className="input-field">
                  <label for="name">{t("email_subject_txt")}</label>
                  <input
                    type="text"
                    name="emailSubject"
                    value={emailTemplateData.emailSubject}
                    onChange={handleOnChange}
                  />
                  {errors.emailSubject && (
                    <div className="error-msg">{errors.emailSubject}</div>
                  )}
                </div>

                <div className="input-field">
                  <label for="name">{t("included_txt")}</label>
                  <div className="full-text-toggle custom_check-box">
                    <div className="check-box">
                      <>
                        <input
                          type="checkbox"
                          id="header"
                          checked={emailTemplateData.header} // controlled value
                          onChange={(e) =>
                            handleOnCheck(e.target.checked, "header")
                          } // update state
                        />
                        <label htmlFor="header">{t("add_header_txt")}</label>{" "}
                        &nbsp;&nbsp;&nbsp;
                      </>
                      <>
                        <input
                          type="checkbox"
                          id="footer"
                          checked={emailTemplateData.footer} // controlled value
                          onChange={(e) =>
                            handleOnCheck(e.target.checked, "footer")
                          }
                        />
                      </>
                      <label htmlFor="footer">{t("add_footer_txt")}</label>
                    </div>
                  </div>
                  {errors.emailSubject && (
                    <div className="error-msg">{errors.emailSubject}</div>
                  )}
                </div>

                <div className="input-field">
                  <label for="name">{t("email_content_txt")}</label>
                  <EmailDynamicContentInfo
                    emailType={emailTemplateData.emailType}
                  />
                  <br />
                  <div className="email-editor-wrapper">
                    <RichTextEditor
                      emailContent={emailTemplateData.emailContent}
                      handleChangeEmailContent={handleChangeEmailContent}
                    />
                  </div>
                  {errors.emailContent && (
                    <div className="error-msg">{errors.emailContent}</div>
                  )}
                </div>

                {(emailTemplateData.emailType === "logged_in_not_order" ||
                  emailTemplateData.emailType === "abandoned_cart" ||
                  emailTemplateData.emailType ===
                    "logged_in_not_order_cutoff") && (
                  <>
                    <br />
                    <div className="flex-bx-wrap col3">
                      <div className="flex-bx-item">
                        <div className="input-field">
                          <label htmlFor="reminderCountLimit">
                            {t("reminder_limit_txt")}
                          </label>

                          <input
                            type="number"
                            name="reminderCountLimit"
                            value={emailTemplateData.reminderCountLimit}
                            placeholder={t("reminder_limit_text")}
                            min="1"
                            onKeyDown={(e) => {
                              // Disallow: "-", "+", ".", "e", "E"
                              if (["-", "+", ".", "e", "E"].includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={handleIntervalChange}
                          />
                          {errors.reminderCountLimit && (
                            <div className="error-msg">
                              {errors.reminderCountLimit}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="flex-bx-item">
                        <div className="input-field">
                          <label htmlFor="reminderInterval">
                            {t("reminder_email_interval_txt")}
                            {/* {emailTemplateData.reminderInterval > 23 && (
                              <span className="note-text">
                                {" - "}
                                {formatHoursToDays(
                                  emailTemplateData.reminderInterval
                                )}
                              </span>
                            )} */}
                          </label>
                          {/* Dropdown */}
                          <select
                            name="reminderIntervalDropdown"
                            value={
                              isCustomInterval
                                ? "custom"
                                : emailTemplateData.reminderInterval || ""
                            }
                            onChange={(e) => {
                              const val = e.target.value;

                              if (val === "custom") {
                                // User selected "Custom"
                                setIsCustomInterval(true);
                                setCustomInterval(""); // reset custom input
                                setEmailTemplateData((prev) => ({
                                  ...prev,
                                  reminderInterval: "",
                                }));
                              } else if (val === "") {
                                // User selected "Select"
                                setIsCustomInterval(false);
                                setEmailTemplateData((prev) => ({
                                  ...prev,
                                  reminderInterval: "",
                                }));
                              } else {
                                // User selected 24/48/96
                                setIsCustomInterval(false);
                                setEmailTemplateData((prev) => ({
                                  ...prev,
                                  reminderInterval: parseInt(val, 10),
                                }));
                              }
                              setErrors((prev) => ({
                                ...prev,
                                reminderInterval: "",
                              }));
                            }}
                          >
                            <option value="">{t("select_txt")}</option>
                            <option value="24">24</option>
                            <option value="48">48</option>
                            <option value="96">96</option>
                            <option value="custom">{t("custom_txt")}</option>
                          </select>
                          {!isCustomInterval && errors.reminderInterval && (
                            <div className="error-msg">
                              {errors.reminderInterval}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* Show custom input only if "Custom" is selected */}
                      {isCustomInterval && (
                        <div className="flex-bx-item">
                          <div className="input-field">
                            <label>
                              {t("add_custom_hours_txt")}
                              {/* {emailTemplateData.reminderInterval > 23 && (
                                <span className="note-text">
                                  {" - "}
                                  {formatHoursToDays(
                                    emailTemplateData.reminderInterval
                                  )}
                                </span>
                              )} */}
                            </label>
                            <input
                              type="number"
                              name="reminderInterval"
                              value={emailTemplateData.reminderInterval}
                              placeholder={t("custom_hrs_text")}
                              min="1"
                              onKeyDown={(e) => {
                                if (["-", "+", ".", "e", "E"].includes(e.key))
                                  e.preventDefault();
                              }}
                              onChange={(e) => {
                                const val = e.target.value;
                                setCustomInterval(val);
                                setEmailTemplateData((prev) => ({
                                  ...prev,
                                  reminderInterval:
                                    val === "" ? "" : parseInt(val, 10),
                                }));
                                setErrors((prev) => ({
                                  ...prev,
                                  reminderInterval: "",
                                }));
                              }}
                            />
                            {errors.customReminderInterval && (
                              <div className="error-msg">
                                {errors.customReminderInterval}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {errors.reminderInterval && (
                        <div className="error-msg">
                          {errors.reminderInterval}
                        </div>
                      )}
                    </div>

                    <div className="input-field">
                      <label for="name">
                        {t("reminder_email_subject_txt")}
                      </label>
                      <input
                        type="text"
                        name="reminderEmailSubject"
                        value={emailTemplateData.reminderEmailSubject}
                        onChange={handleOnChange}
                      />
                      {errors.reminderEmailSubject && (
                        <div className="error-msg">
                          {errors.reminderEmailSubject}
                        </div>
                      )}
                    </div>

                    <div className="input-field">
                      <label for="name">
                        {t("reminder_email_included_txt")}
                      </label>
                      <div className="full-text-toggle custom_check-box">
                        <div className="check-box">
                          <>
                            <input
                              type="checkbox"
                              id="reminderHeader"
                              checked={emailTemplateData.reminderHeader} // controlled value
                              onChange={(e) =>
                                handleOnCheck(
                                  e.target.checked,
                                  "reminderHeader"
                                )
                              } // update state
                            />
                            <label htmlFor="reminderHeader">
                              {t("add_header_txt")}
                            </label>{" "}
                            &nbsp;&nbsp;&nbsp;
                          </>
                          <>
                            <input
                              type="checkbox"
                              id="reminderFooter"
                              checked={emailTemplateData.reminderFooter} // controlled value
                              onChange={(e) =>
                                handleOnCheck(
                                  e.target.checked,
                                  "reminderFooter"
                                )
                              }
                            />
                          </>
                          <label htmlFor="reminderFooter">
                            {t("add_footer_txt")}
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="input-field">
                      <label for="name">
                        {t("reminder_email_content_txt")}
                      </label>
                      <EmailDynamicContentInfo
                        emailType={emailTemplateData.emailType}
                      />
                      <br />
                      <div className="email-editor-wrapper">
                        <RichTextEditor
                          emailContent={emailTemplateData.reminderEmailContent}
                          handleChangeEmailContent={
                            handleChangeReminderEmailContent
                          }
                        />
                      </div>
                      {errors.reminderEmailContent && (
                        <div className="error-msg">
                          {errors.reminderEmailContent}
                        </div>
                      )}
                    </div>
                  </>
                )}

                <div className="btnfield">
                  <button
                    type="submit"
                    name="emailTemplateSubmit"
                    onClick={handleSubmit}
                  >
                    {t("submit_txt")}
                  </button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" onClick={routeChange}>
                    {t("cancel_txt")}
                  </button>
                </div>
              </form>
              {/* </div> */}
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </section>
  );
};

export default AddEmailConfig;
